<template>
  <div style="display: inline-block">
    <v-btn
      v-if="livechat && !['qa', 'reporter'].includes($store.state.privilege.role)"
      color="primary"
      outline
      small
      fab
      @click="openModal"
      ><v-icon>edit</v-icon></v-btn
    >

    <v-dialog v-model="showManage" persistent max-width="600">
      <v-card v-if="showManage">
        <v-layout class="px-3">
          <v-flex style="display: flex; align-items: center">
            <h3 class="title ma-0">{{ type == 'add' ? 'Add' : 'Edit' }} Ticket</h3>
          </v-flex>
          <v-flex class="text-xs-right">
            <v-btn class="ma-0" fab flat :loading="loading || loadingTicket" @click="onCancel">
              <v-icon>close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-divider />
        <v-card-text>
          <v-layout wrap>
            <v-flex
              xs12
              sm6
              class="form-control px-1"
              :class="{ 'has-error': errors.has('firstname') }"
            >
              <div class="caption mb-1 mt-2">Customer First Name *</div>
              <div
                v-if="['facebook', 'line', 'x', 'pantip'].includes(ticket.channel)"
                class="primary--text mb-3"
              >
                {{ ticket.contact_firstname || '-' }}
              </div>
              <template v-else>
                <v-text-field
                  v-model="ticket.contact_firstname"
                  v-validate="'required'"
                  outline
                  type="text"
                  :placeholder="$t('customer first name')"
                  class="default-input"
                  maxlength="255"
                  :data-vv-as="$t('Customer First Name')"
                  name="firstname"
                  :hide-details="!errors.has('firstname')"
                  :error="errors.has('firstname')"
                  :error-messages="errors.first('firstname')"
                />
              </template>
            </v-flex>
            <v-flex xs12 sm6 class="form-control px-1">
              <div class="caption mb-1 mt-2">Customer Last Name</div>
              <div
                v-if="['facebook', 'line', 'x', 'pantip'].includes(ticket.channel)"
                class="primary--text mb-3"
              >
                {{ ticket.contact_lastname || '-' }}
              </div>
              <template v-else>
                <v-text-field
                  v-model="ticket.contact_lastname"
                  outline
                  type="text"
                  :placeholder="$t('customer last name')"
                  class="default-input"
                  maxlength="255"
                  hide-details
                />
              </template>
            </v-flex>
            <v-flex xs12 sm6 class="form-control px-1">
              <div class="caption mb-1 mt-2">{{ $t('Page') }}</div>
              <div class="primary--text mb-3">{{ ticket.customer_page_name || '-' }}</div>
            </v-flex>
            <v-flex xs12 sm6 class="form-control px-1">
              <div class="caption mb-1 mt-2">{{ $t('Channel') }}</div>
              <div class="primary--text mb-3">{{ ticket.channel || '-' }}</div>
            </v-flex>
            <v-flex xs12 sm6 class="form-control px-1">
              <div class="caption mb-1 mt-2">Platform Type</div>
              <div class="primary--text mb-3">
                {{
                  ticket.platform_type === 'inbox'
                    ? $t('all_in_one_chat.inbox')
                    : ticket.platform_type === 'page'
                    ? $t('all_in_one_chat.post')
                    : '-'
                }}
              </div>
            </v-flex>
            <v-flex xs12 sm6 class="form-control px-1">
              <div class="caption mb-1 mt-2">Thread ID</div>
              <div class="primary--text mb-3">{{ ticket.thread_id || '-' }}</div>
            </v-flex>
            <v-flex xs12 sm6 class="form-control px-1">
              <div class="caption mb-1 mt-2">Post ID</div>
              <div class="primary--text mb-3">{{ ticket.postid || '-' }}</div>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider />
        <v-card-text>
          <v-layout wrap>
            <v-flex
              xs12
              sm6
              class="form-control px-1 pb-2"
              :class="{ 'has-error': errors.has('group') }"
            >
              <div class="caption mb-1 mt-2">Group *</div>
              <v-autocomplete
                v-model="ticket.group"
                v-validate="'required'"
                return-object
                name="group"
                :loading="loading"
                :items="agentGroup"
                outline
                clearable
                :item-text="'groupname'"
                :item-value="'groupname'"
                class="default-input-textfield"
                single-line
                :hide-details="!errors.has('group')"
                :error="errors.has('group')"
                :error-messages="errors.first('group')"
                :placeholder="$t('Group')"
                @change="onChangeGroup"
              />
            </v-flex>
            <v-flex xs12 sm6 class="form-control px-1 pb-2">
              <div class="caption mb-1 mt-2">Subgroup</div>
              <v-autocomplete
                v-model="ticket.subgroup"
                return-object
                name="subgroup"
                :loading="loading"
                :items="filterSubGroup"
                outline
                clearable
                :item-text="'subgroupname'"
                :item-value="'subgroupname'"
                class="default-input-textfield"
                single-line
                :hide-details="!errors.has('subgroup')"
                :error="errors.has('subgroup')"
                :error-messages="errors.first('subgroup')"
                :placeholder="$t('Sub Group')"
                @change="onChangeSubGroup"
              />
            </v-flex>
            <v-flex xs12 sm12 class="form-control px-1 pb-2">
              <div class="caption mb-1 mt-2">Assigned to</div>
              <v-autocomplete
                v-model="ticket.assignedTo"
                return-object
                name="assignedTo"
                :loading="loading"
                :items="filterAgents"
                outline
                clearable
                :item-text="'name'"
                :item-value="'name'"
                class="default-input-textfield"
                single-line
                :hide-details="!errors.has('assignedTo')"
                :error="errors.has('assignedTo')"
                :error-messages="errors.first('assignedTo')"
                :placeholder="$t('Assigned To')"
              />
            </v-flex>
            <v-flex
              xs12
              sm12
              class="form-control px-1"
              :class="{ 'has-error': errors.has('topic') }"
            >
              <div class="caption mb-1 mt-2">Topic *</div>
              <v-text-field
                v-model="ticket.subject"
                v-validate="'required'"
                outline
                type="text"
                :placeholder="$t('topic')"
                class="default-input"
                maxlength="255"
                :data-vv-as="$t('topic')"
                name="topic"
                :hide-details="!errors.has('topic')"
                :error="errors.has('topic')"
                :error-messages="errors.first('topic')"
              />
            </v-flex>
            <v-flex
              xs12
              sm12
              class="form-control px-1"
              :class="{ 'has-error': errors.has('details') }"
            >
              <div class="caption mb-1 mt-2">Details *</div>
              <v-text-field
                v-model="ticket.details"
                v-validate="'required'"
                outline
                type="text"
                :placeholder="$t('Details')"
                class="default-input"
                maxlength="255"
                :data-vv-as="$t('Details')"
                name="details"
                :hide-details="!errors.has('details')"
                :error="errors.has('details')"
                :error-messages="errors.first('details')"
              />
            </v-flex>
            <v-flex xs12 sm12 class="form-control px-1">
              <div class="caption mb-1 mt-2">Comment</div>
              <v-textarea
                v-model="ticket.comment"
                outline
                :placeholder="$t('comment')"
                class="default-input-textfield"
                name="comment"
                rows="3"
                hide-details
              />
            </v-flex>

            <v-flex xs12 sm6 class="form-control px-1">
              <div class="caption mb-1 mt-2">Priority *</div>
              <v-autocomplete
                v-model="priority"
                v-validate="'required'"
                return-object
                name="priority"
                :loading="loading"
                :items="priorityOptions"
                outline
                clearable
                :item-text="'text'"
                :item-value="'value'"
                class="default-input-textfield"
                single-line
                :hide-details="!errors.has('priority')"
                :error="errors.has('priority')"
                :error-messages="errors.first('priority')"
                placeholder="Priority"
              />
            </v-flex>
            <v-flex
              xs12
              sm6
              class="form-control px-1 pb-2"
              :class="{ 'has-error': errors.has('status') }"
            >
              <div class="caption mb-1 mt-2">Status *</div>
              <v-autocomplete
                v-model="ticket.status"
                v-validate="'required'"
                disabled
                name="status"
                :loading="loading"
                :items="statusOptions"
                outline
                clearable
                class="default-input-textfield"
                single-line
                :hide-details="!errors.has('status')"
                :error="errors.has('status')"
                :error-messages="errors.first('status')"
                placeholder="Status"
              />
            </v-flex>
            <v-flex xs12 class="form-control px-1 pb-2">
              <div class="caption mb-1 mt-2">Mood</div>
              <v-radio-group
                v-model="ticket.mood"
                d-inline
                row
                name="mood"
                class="mt-0"
                hide-details
              >
                <v-radio class="mb-2" :value="'positive'" color="primary" label="Positive" />
                <v-radio class="mb-2" :value="'neutral'" color="primary" label="Neutral" />
                <v-radio class="mb-2" :value="'negative'" color="primary" label="Negative" />
              </v-radio-group>
            </v-flex>
            <v-flex xs12>
              <div class="caption mb-1 mt-2">Tags</div>
              <v-combobox
                v-model="tags"
                :filter="tagsfilter"
                :hide-no-data="!tagssearch"
                :items="tagitems"
                :search-input.sync="tagssearch"
                hide-selected
                label="Search for an option"
                multiple
                small-chips
                solo
                flat
                outline
              >
                <template #no-data>
                  <v-list-tile>
                    <span class="subheading">Create</span>
                    <v-chip :color="`primary lighten-3`" label small>{{ tagssearch }}</v-chip>
                  </v-list-tile>
                </template>
                <template #selection="{ item, parent, selected }">
                  <v-chip
                    v-if="item === Object(item)"
                    :color="`primary lighten-3`"
                    :selected="selected"
                    label
                    small
                  >
                    <span class="pr-2">{{ item.text }}</span>
                    <v-icon small @click="parent.selectItem(item)">close</v-icon>
                  </v-chip>
                </template>
                <template #item="{ index, item }">
                  <v-list-tile-content>
                    <v-text-field
                      v-if="tagediting === item"
                      v-model="tagediting.text"
                      autofocus
                      flat
                      background-color="transparent"
                      hide-details
                      solo
                      @keyup.enter="tagsedit(index, item)"
                    ></v-text-field>
                    <v-chip v-else :color="`primary lighten-3`" label small>{{ item.text }}</v-chip>
                  </v-list-tile-content>
                  <v-spacer></v-spacer>
                  <v-list-tile-action @click.stop>
                    <v-btn icon @click.stop.prevent="tagsedit(index, item)">
                      <v-icon>{{ tagediting !== item ? 'edit' : 'check' }}</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </template>
              </v-combobox>
            </v-flex>
            <v-flex xs12 class="mb-2">
              <div class="caption mb-1 mt-2">Wrap up *</div>
              <WrapUpManage
                v-model="ticket.wrap_up_route"
                @onUpdateWrapUpData="handleUpdateWrapData"
              />
              <input
                v-model="ticket.wrap_up"
                v-validate="'required'"
                type="hidden"
                name="wrap_up"
                data-vv-as="Wrap up"
              />

              <div class="form-control" :class="{ 'has-error': errors.has('wrap_up') }">
                <p v-if="errors.has('wrap_up')" class="text-error">{{ errors.first('wrap_up') }}</p>
              </div>

              <div
                v-if="isShowNote"
                class="form-control px-1"
                :class="{ 'has-error': errors.has('note') }"
              >
                <v-textarea
                  id="ticketNote"
                  v-model="ticket.note"
                  v-validate="!isWrapUpNoteNotRequired ? 'required' : ''"
                  outline
                  type="text"
                  :placeholder="'Note'"
                  class="default-input-textfield"
                  maxlength="255"
                  :data-vv-as="'Note'"
                  name="note"
                  :hide-details="!errors.has('note')"
                  :error-messages="errors.first('note')"
                  rows="3"
                />
              </div>
            </v-flex>
            <v-flex style="display: flex; justify-content: flex-end">
              <div>
                <v-btn outline color="grey" :loading="loading || loadingTicket" @click="onCancel">
                  {{ $t('cancel') }}
                </v-btn>
                <v-btn
                  color="primary"
                  depressed
                  :disabled="
                    ticket.status === 'closed with survey' || ticket.platform_type === 'page'
                  "
                  :loading="loading || loadingTicket"
                  @click="onSave('closed with survey')"
                  >{{ $t('save_with_survey') }}</v-btn
                >
                <v-btn
                  color="primary"
                  outline
                  :loading="loading || loadingTicket"
                  @click="onSave('closed without survey')"
                  >{{ $t('save_without_survey') }}</v-btn
                >
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ManageTicket from './ManageTicket.js'
export default {
  mixins: [ManageTicket],
  computed: {
    isWrapUpNoteNotRequired() {
      return this.ticket.wrap_up_route.includes('Reject case')
    }
  }
}
</script>

<style lang="scss">
.form-control.has-error textarea#ticketNote {
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/ticket/FormTicketManage.vue